import { useVersionWatcher } from "@/hooks/use-version-watcher";

/**
 * IR-1412 r2: small fixed banner shown when the version watcher detects a new
 * deploy while the tab is visible. Rendered at the App shell level so it
 * covers every page ("in all tabs"). Renders nothing until then.
 */
export function VersionUpdateBanner() {
  const { updateAvailable, refresh, dismiss } = useVersionWatcher();

  if (!updateAvailable) return null;

  return (
    // <output> carries an implicit role="status" (biome useSemanticElements).
    <output
      className="iris-card"
      style={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 14px",
        fontSize: 13,
      }}
    >
      <span>A new version of OPS is available</span>
      <button type="button" className="iris-btn" onClick={refresh}>
        Refresh
      </button>
      <button type="button" className="iris-btn" onClick={dismiss} aria-label="Dismiss">
        Dismiss
      </button>
    </output>
  );
}
